import {Table} from "react-bootstrap";
import { Fragment } from "react";
import {ValidationMessageTypeIcon} from "../StatusIcons/ValidationMessageTypeIcon";
import {useValidation} from "../validation/validation";
import { IngestionMessage, MessageScope, MessageSource } from "../asset-service-api";
import { useProjects } from "../Behaviors/projects";
import { useStore } from "../State/zustandStore";
import { ReportButton } from "../Buttons/Buttons";

const getMessageKey =
    (
        message: IngestionMessage |
        {
            message: string;
            messageType: string;
            timeStamp?: string | undefined;
            details?: string | null | undefined;
            source?: MessageSource | undefined;
        }) => {
        return `${message.source?.id}:${message.timeStamp}:${message.source?.target}:${message.message}`;
    };

interface Props {
    projectId?: string /* The '?' makes projectId optional */
}

export const Messages = ({ projectId }: Props) => {
    const workspaceState = useStore().projects;
    const projId = projectId
        ? projectId
        : workspaceState.selectedProjectId;
    const { project } = useProjects(projId);
    const jobId = project?.jobId;
    const { getPendingUploadMessages, getValidationErrors, getValidationRestrictions, getValidationWarnings } = useValidation();
    const messages =
        getPendingUploadMessages(jobId)
            .concat(getValidationErrors(jobId))
            .concat(getValidationRestrictions(jobId))
            .concat(getValidationWarnings(jobId));
    const filteredMessages = Array.from(messages).filter(x => x.messageType !== "Information" && x.source?.scope !== "URI");
    const getTarget = (message: IngestionMessage) => {
        if (message.source?.scope === MessageScope.Resource) {
            return project?.resourceInfo?.isrc;
        }
        return message.source?.target;
    };
    return (
        <>
            <div>
                <span className="h3">Errors / Restrictions / Warnings</span>
                <span className="float-end"><ReportButton /></span>
            </div>
            <Table className={"error-messages"} role={"list"} responsive="xl" size="sm">
                <tbody>
                    <tr className={"shift-hidden"}>
                        <td colSpan={6}>Job Id: {jobId}</td>
                    </tr>
                    {
                        filteredMessages.map(message => {
                            return (
                                <Fragment key={getMessageKey(message)}>
                                    <tr>
                                        <td className={"iconic"}>
                                            <ValidationMessageTypeIcon messageType={message.messageType!} />
                                        </td>
                                        <td style={{width: "50"}}>
                                            {message.source?.scope}
                                        </td>
                                        <td className={"shift-hidden"}>
                                            {message.source?.id}
                                        </td>
                                        <td className={"shift-hidden"}>
                                            {message.source?.name}
                                        </td>
                                        <td className={"shift-hidden"}>
                                            {message.timeStamp}
                                        </td>
                                        <td style={{width: "50"}} >
                                            {getTarget(message as IngestionMessage)}
                                        </td>
                                        <td style={{width: "100%"}}>
                                            {message.message}
                                        </td>
                                    </tr>
                                    {message.details ? <tr className={"shift-hidden"}>
                                        <td>{message.details}</td>
                                    </tr>
                                        : null}
                                </Fragment>
                            );
                        })}
                    <tr className={"filler-row"}><td> </td></tr>

                </tbody>
            </Table>
        </>
    );
};
